import { render } from "./project-subject-config.vue?vue&type=template&id=22f09e4e&scoped=true&ts=true"
import script from "./project-subject-config.vue?vue&type=script&lang=ts"
export * from "./project-subject-config.vue?vue&type=script&lang=ts"

import "./project-subject-config.vue?vue&type=style&index=0&id=22f09e4e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f09e4e"]])

export default __exports__